// extracted by mini-css-extract-plugin
export var root = "qTJmhYVU3bavyaR5U3Hq";